// extracted by mini-css-extract-plugin
export var input = "input-module--input--3b176";
export var labelText = "input-module--label-text--504f6";
export var textarea = "input-module--textarea--7eb2d";